/* eslint-disable react/jsx-no-constructed-context-values */
import React, { createContext, useState, useContext } from 'react';
import CustomToast from '../Components/AlertPopup';

const ToastContext = createContext();

export function ToastProvider({ children }) {
    const [toast, setToast] = useState({
        open: false,
        message: '',
        color: '#309A5D',
    });

    const showToast = (message, color = '#309A5D') => {
        setToast({ open: true, message, color });

        // Auto-hide toast after 3 seconds
        setTimeout(() => {
            setToast((prev) => ({ ...prev, open: false }));
        }, 3000);
    };

    const hideToast = () => {
        setToast((prev) => ({ ...prev, open: false }));
    };

    return (
        <ToastContext.Provider value={{ showToast, hideToast }}>
            {children}
            <div style={{ zIndex: 99999 }}>
                <CustomToast
                    open={toast.open}
                    message={toast.message}
                    setopen={hideToast}
                    color={toast.color}
                />
            </div>
        </ToastContext.Provider>
    );
}

export const useToast = () => useContext(ToastContext);
